import { Router } from 'express';
import * as controller from './users.controller';
import { authMiddleware } from '../../middleware/auth.middleware';
import { requirePermission } from '../../middleware/rbac.middleware';

import multer from 'multer';
import fs from 'fs';
import path from 'path';

const router = Router();

const recordingStorage = multer.diskStorage({
  destination: (_req, _file, cb) => {
    const dest = path.join(process.cwd(), 'uploads', 'call_recordings');
    fs.mkdirSync(dest, { recursive: true });
    cb(null, dest);
  },
  filename: (_req, file, cb) => {
    const uniqueSuffix = Date.now() + '-' + Math.round(Math.random() * 1E9);
    const ext = path.extname(file.originalname) || '.wav';
    cb(null, `rec-${uniqueSuffix}${ext}`);
  }
});

const uploadRecording = multer({
  storage: recordingStorage,
  limits: { fileSize: 500 * 1024 * 1024 }
});

// Require authentication for all user routes
router.use(authMiddleware);

// Search needs to be before /:id to prevent "search" being treated as an ID
router.get('/search', controller.search);

// Call history & recording for current user
router.get('/me/call-history', controller.getCallHistory);
router.post('/me/call-recording', uploadRecording.single('recording'), controller.uploadCallRecording);

// Profiles and Listing
router.get('/', controller.list);
router.get('/:id', controller.getById);
router.get('/username/:username', controller.getByUsername);
router.patch('/me', controller.updateMe);
router.post('/presence/bulk', controller.presenceBulk);

// Admin / User Management endpoints
router.post('/', requirePermission('manage_users'), controller.create);
router.patch('/:id', requirePermission('manage_users'), controller.update);
router.post('/:id/activate', requirePermission('manage_users'), controller.activate);
router.post('/:id/deactivate', requirePermission('manage_users'), controller.deactivate);
router.delete('/:id', requirePermission('manage_users'), controller.destroy);
router.post('/:id/visibility', requirePermission('manage_users'), controller.assignVisibility);

export default router;
